import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import memoize from 'memoize-one';

import {
  List,
  AutoSizer,
  CellMeasurer,
  CellMeasurerCache,
} from 'react-virtualized';
import InfinityLoader from 'react-virtualized/dist/es/InfiniteLoader';
import ToolTipWrapper from '../ToolTipWrapper/ToolTipWrapper';

import './MediaLibraryFull.scss';
import {
  MEDIA_AUTHOR,
  TEXT_FIELD_STATUS,
  SUCCESS,
} from '../../../utils/constants';
import BottomToast from '../BottomToast/BottomToast';
import Button from '../../_atomic/Button/Button';
import DashboardFilter from '../DashboardFilter/DashboardFilter';
import MediaLibraryPlaceholder from '../../_atomic/MediaLibraryPlaceholder/MediaLibraryPlaceholder';
import ImageButton from '../../_atomic/ImageButton/ImageButton';
import MediaPreviewModal from './components/MediaPreviewModal/MediaPreviewModal';
import ArrowButton from '../../_atomic/ArrowButton/ArrowButton';

const roundCheck = require('./assets/round-check.png');
const placeholder = require('./assets/no-media.png');
const downloadIcon = require('./assets/download.svg');
const zoomIcon = require('./assets/zoom-icon.png');


const campaignFilterName = 'campaign-filter';
const appFilterName = 'app-filter';

const cache = new CellMeasurerCache({
  fixedWidth: true,
  minHeight: 329,
});

class MediaLibraryFull extends Component {
  static propTypes = {
    mediaApps: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    appId: PropTypes.string.isRequired,
    campaignId: PropTypes.string.isRequired,
    deleteMedia: PropTypes.func.isRequired,
    attachMedia: PropTypes.func.isRequired,
    loadMedia: PropTypes.func.isRequired,
    hasMoreMediaApps: PropTypes.bool.isRequired,
    pageMediaApps: PropTypes.string.isRequired,
    apps: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    currentAppCampaigns: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    getAppCampaigns: PropTypes.func.isRequired,
    getAppMediaStatus: PropTypes.string.isRequired,
    isAdmin: PropTypes.bool,
    sidebarStatus: PropTypes.bool,
  };

  static defaultProps = {
    isAdmin: false,
    sidebarStatus: true,
  };

  state = {
    sortedMedias: {},
    selectedMedias: [],
    filters: {
      [campaignFilterName]: {
        value: '',
        status: TEXT_FIELD_STATUS.INITIAL,
      },
      [appFilterName]: {
        value: '',
        status: TEXT_FIELD_STATUS.INITIAL,
      },
    },
    showPreviewModal: false,
    previewModalLink: '',
    previewModalDimensions: {
      width: 0,
      height: 0,
    },
    allowDownload: false,
  };

  componentDidUpdate(prevProps) {
    const { mediaApps, pageMediaApps, getAppMediaStatus } = this.props;

    if (JSON.stringify(mediaApps) !== JSON.stringify(prevProps.mediaApps)) {
      this.sortMedias(mediaApps);
      this.loadedResolved();
      if (mediaApps.length === 1 || prevProps.mediaApps.length === 1) {
        this.virtualElement.forceUpdateGrid();
      }
    }
    if (
      getAppMediaStatus !== prevProps.getAppMediaStatus &&
      getAppMediaStatus === SUCCESS
    ) {
      cache.clearAll();
      this.sortMedias(mediaApps, true);
    }
    if (pageMediaApps < 5) {
      cache.clearAll();
    }
  }
  attachMedia = () => {
    const { campaignId, attachMedia } = this.props;
    const { selectedMedias } = this.state;
    attachMedia({ campaignId, media: selectedMedias });
  };

  sortMedias = (apps, forceUpdate) => {
    const sortedMedias = {
      ...this.state.sortedMedias,
    };
    const selectedMedias = [...this.state.selectedMedias];
    const { campaignId } = this.props;
    apps.forEach((app) => {
      if (!sortedMedias[app.app.id]) {
        sortedMedias[app.app.id] = {};
      }
      app.medias.forEach((mediaItem) => {
        if (!sortedMedias[app.app.id][mediaItem.author]) {
          sortedMedias[app.app.id][mediaItem.author] = [mediaItem];
        } else {
          const index = sortedMedias[app.app.id][mediaItem.author]
            .findIndex(sortedMediaItem => sortedMediaItem.id === mediaItem.id);
          if (index === -1) {
            sortedMedias[app.app.id][mediaItem.author].push(mediaItem);
          }
        }
        if (mediaItem.author === MEDIA_AUTHOR.USER) {
          const campaignInMediaIndex = mediaItem.campaigns
            .findIndex(campaign => campaign.id === campaignId);
          if (
            campaignInMediaIndex > -1 &&
            selectedMedias.indexOf(mediaItem.id) === -1
          ) {
            selectedMedias.push(mediaItem.id);
          }
        }
      });
    });
    this.setState(
      () => ({ sortedMedias, selectedMedias }),
      () => {
        if (this.loadedResolved) {
          this.loadedResolved();
        }

        if (forceUpdate) {
          this.virtualElement.forceUpdateGrid();
        }
      },
    );
  };

  isRowLoaded = ({ index }) => {
    const { mediaApps } = this.props;
    return !!(mediaApps[index]);
  };

  showPreviewModal = (link, dimensions, allowDownload) => {
    let previewModalDimensions = { ...this.state.previewModalDimensions };
    previewModalDimensions = dimensions;
    this.setState(() => ({
      showPreviewModal: true,
      previewModalLink: link,
      previewModalDimensions,
      allowDownload,
    }));
  };

  hidePreviewModal = () => {
    let previewModalDimensions = { ...this.state.previewModalDimensions };
    previewModalDimensions = {
      width: 0,
      height: 0,
    };
    this.setState(() => ({
      showPreviewModal: false,
      previewModalLink: '',
      previewModalDimensions,
    }));
  };
  navigateToBack = () => {
    window.history.back();
  }
  loadMoreRows = ({ isFirst }) => {
    const { hasMoreMediaApps, pageMediaApps, loadMedia } = this.props;
    const { filters } = this.state;

    const appId = filters[appFilterName].value;
    if (isFirst) {
      loadMedia({ page: 0, appId });
      return new Promise((resolve) => {
        this.loadedResolved = resolve;
      });
    } else if (hasMoreMediaApps) {
      loadMedia({ page: pageMediaApps + 1 });
      return new Promise((resolve) => {
        this.loadedResolved = resolve;
      });
    }

    return () => {};
  };

  rowRenderer = ({
    index, key, style, parent,
  }) => {
    let content;
    const { mediaApps } = this.props;
    const { sortedMedias, filters } = this.state;

    if (!this.isRowLoaded({ index })) {
      content = null;
    } else {
      const currentApp = mediaApps[index];
      content = (
        <div style={style}>
          {this.renderAppMedia(
            currentApp,
            sortedMedias,
            filters[campaignFilterName].value,
          )}
        </div>
      );
    }

    return (
      <CellMeasurer
        cache={cache}
        columnIndex={0}
        key={key}
        parent={parent}
        rowIndex={index}
      >
        {content}
      </CellMeasurer>
    );
  };
  deleteMediaLocally = (id) => {
    const sortedMedias = {
      ...this.state.sortedMedias,
    };
    Object.keys(sortedMedias).forEach((app) => {
      Object.keys(sortedMedias[app]).forEach((authorName) => {
        const index = sortedMedias[app][authorName].findIndex(media => media.id === id);
        if (index > -1) {
          sortedMedias[app][authorName].splice(index, 1);
        }
      });
    });

    this.setState(
      () => ({
        sortedMedias,
      }),
      () => {
        this.virtualElement.forceUpdateGrid();
      },
    );
  };

  filterChangeHandler = ({ value, name }) => {
    const filters = {
      ...this.state.filters,
    };
    if (value) {
      filters[name].status = TEXT_FIELD_STATUS.VALID;
    } else {
      filters[name].status = TEXT_FIELD_STATUS.INITIAL;
    }
    if (name === appFilterName) {
      filters[campaignFilterName].value = '';
    }

    filters[name].value = value.value;

    this.setState(
      () => ({
        filters,
      }),
      () => {
        if (name === appFilterName) {
          this.props.getAppCampaigns({ appId: filters[name].value });
          this.loadMoreRows({ isFirst: true });
        }
        if (name === campaignFilterName) {
          this.virtualElement.forceUpdateGrid();
        }
      },
    );
  };

  selectMediaHandler = (id) => {
    const selectedMedias = [...this.state.selectedMedias];
    const sortedMedias = {
      ...this.state.sortedMedias,
    };
    const { deleteMedia, campaignId, appId } = this.props;
    const mediaIndex = selectedMedias.indexOf(id);
    if (mediaIndex === -1) {
      selectedMedias.push(id);
    } else {
      selectedMedias.splice(mediaIndex, 1);

      if (campaignId && appId) {
        sortedMedias[appId][MEDIA_AUTHOR.USER].forEach((media) => {
          if (media.campaigns[0].id === campaignId && media.id === id) {
            this.deleteMediaLocally(id);
            deleteMedia(id);
          }
        });
      }
    }

    this.setState(
      () => ({ selectedMedias }),
      () => {
        this.virtualElement.forceUpdateGrid();
      },
    );
  };

  transformWithFirstValue = memoize(apps => [
    ...[{ value: '', label: 'All' }],
    ...apps,
  ]);

  filterMediasByCampaigns = (medias, campaignId) => {
    if (!campaignId) {
      return medias;
    }

    return (
      medias &&
      medias.filter((media) => {
        const index = media.campaigns.findIndex(campaign => campaign.id === campaignId);
        if (index > -1) return true;
        return false;
      })
    );
  };

  resetSelect = () => {
    this.setState(() => ({
      selectedMedias: [],
    }), () => {
      this.virtualElement.forceUpdateGrid();
    });
  };
  deleteSelected = () => {
    const selectedMedias = [...this.state.selectedMedias];

    selectedMedias.forEach((id) => {
      this.deleteMediaLocally(id);
      this.props.deleteMedia(id);
    });
    this.setState(() => ({
      selectedMedias: [],
    }), () => { this.virtualElement.forceUpdateGrid(); });
  };
  renderAppMedia = (app, sortedMedias, campaignFilter) => {
    const currentAppMedias = sortedMedias[app.app.id];
    const campaignIndex = app.campaigns.findIndex(campaign => campaign.id === campaignFilter);
    const { isAdmin } = this.props;
    const userCategoryName = isAdmin ? 'Uploaded by user' : 'Uploaded by you:';
    if (campaignIndex !== -1 || !campaignFilter) {
      return (
        <div className="app-wrapper">
          <div className="app-name">
            <span>{app.app.name}</span>
          </div>
          {currentAppMedias && Object.keys(currentAppMedias).length ? (
            <div className="media-categories">
              {this.renderCategory(
                userCategoryName,
                this.filterMediasByCampaigns(
                  currentAppMedias[MEDIA_AUTHOR.USER],
                  campaignFilter,
                ),
                MEDIA_AUTHOR.USER,
              ) ||
                (campaignFilter && (
                  <span className="plain-text">
                    {' '}
                    No media for selected campaign{' '}
                  </span>
                ))}
              {this.renderCategory(
                'Generated by Advaice:',
                this.filterMediasByCampaigns(
                  currentAppMedias[MEDIA_AUTHOR.ADMIN],
                  campaignFilter,
                ),
                MEDIA_AUTHOR.ADMIN,
              )}
              {this.renderCategory(
                'What competitors use:',
                this.filterMediasByCampaigns(
                  currentAppMedias[MEDIA_AUTHOR.COMPETITOR],
                  campaignFilter,
                ),
                MEDIA_AUTHOR.COMPETITOR,
              )}
            </div>
          ) : (
            <div className="media-wrapper media-placeholder">
              <div className="media-preview-wrapper">
                <div className="media-preview">
                  <img src={placeholder} alt="No media" />
                </div>
              </div>

              <div className="media-name">
                <span>No media for this app</span>
              </div>
            </div>
          )}
        </div>
      );
    }
    return null;
  };

  renderCategory = (categoryName, categoryMedia, author) => {
    if (categoryMedia && categoryMedia.length) {
      return (
        <div className="category-wrapper">
          <div className="category-name">
            <span>{categoryName}</span>
          </div>
          <div className="category-media-wrapper">
            {categoryMedia.map(media => this.renderMediaItem(media, author))}
          </div>
        </div>
      );
    }
    return null;
  };

  renderMediaItem = (media, author) => {
    const {
      preview, campaigns, name, dimension, source,
    } = media;
    const { selectedMedias } = this.state;
    const { isAdmin } = this.props;
    const mediaItemClassNames = classNames({
      'media-wrapper': true,
      'show-select': selectedMedias.length,
      selected: selectedMedias.indexOf(media.id) > -1,
    });
    const renderDownload = isAdmin || author === MEDIA_AUTHOR.USER;
    return (
      <div className={mediaItemClassNames}>
        <div className="media-preview-wrapper">
          <button
            onClick={() => this.selectMediaHandler(media.id)}
            className="media-select-button"
          />
          <div className="media-select-wrapper">
            <svg
              className="checkmark"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 36 36"
            >
              <path
                className="checkmark-check"
                fill="none"
                d="M4.1 17.2l7.1 8.5 16.7-16.8"
              />
            </svg>
          </div>
          <div
            style={{
              backgroundImage: `url(${preview.uri})`,
            }}
            className="media-preview"
          />
          <div className="media-item-overlay">
            <div className="controls-wrapper">
              <div className="zoom-button-wrapper">
                <ImageButton
                  clickHandler={() => {
                    this.showPreviewModal(source.uri, dimension, renderDownload);
                  }}
                  width={32}
                  height={32}
                  className="zoom-button"
                  imgLink={zoomIcon}
                />
              </div>
              {/* eslint-disable */}
              {renderDownload && (
                
                <a href={source.uri} target="_blank" download={name} className="download-button-wrapper">
                 
                  <ImageButton
                    clickHandler={() => {}}
                    width={32}
                    height={32}
                    className="download-button"
                    imgLink={downloadIcon}
                  />
                </a>
              )}
              {/* eslint-enable */}

            </div>
          </div>
        </div>
        {this.renderMediaCampaignNames(campaigns)}
        <div className="media-name">
          <span>{name}</span>
        </div>
        <div className="media-dimension">
          <span>
            {dimension.width}
            x {dimension.height}
          </span>
        </div>
      </div>
    );
  };
  renderMediaCampaignNames = (campaigns) => {
    const campaignNames = campaigns.map(campaign => campaign.name).join(', ');
    const isTooltip = campaignNames.length > 22;
    return (
      <div className="media-campaign-names">
        <ToolTipWrapper isActive={isTooltip} content={campaignNames}>
          <span>{campaignNames}</span>
        </ToolTipWrapper>
      </div>
    );
  };

  render() {
    const {
      campaignId,
      apps,
      currentAppCampaigns,
      hasMoreMediaApps,
      mediaApps,
      sidebarStatus,
    } = this.props;
    const {
      sortedMedias,
      selectedMedias,
      filters,
      showPreviewModal,
      previewModalLink,
      previewModalDimensions,
      allowDownload,
    } = this.state;
    const currentAppFilter = filters[appFilterName];
    const currentCampaignFilter = filters[campaignFilterName];
    const transformedApps = this.transformWithFirstValue(apps);
    const rowCount = hasMoreMediaApps ? mediaApps.length + 1 : mediaApps.length;
    return (
      <div className="media-library-full-wrapper">
        <MediaPreviewModal
          visible={showPreviewModal}
          requestClose={this.hidePreviewModal}
          fileLink={previewModalLink}
          dimension={previewModalDimensions}
          allowDownload={allowDownload}
        />
        <BottomToast isVisible={selectedMedias.length}>
          <div className="counter-wrapper">
            <div className="img-wrapper">
              <img src={roundCheck} alt="checkmark" />
            </div>
            <span>
              {selectedMedias.length}{' '}
              {selectedMedias.length === 1 ? 'file' : 'files'} chosen
            </span>
          </div>
          {campaignId ? (
            <div className="buttons-wrapper">
              <Button label="Save" clickHandler={this.attachMedia} />
            </div>
          ) : (
            <div className="buttons-wrapper">
              <Button label="Delete" clickHandler={this.deleteSelected} />
              <Button
                label="Cancel"
                clickHandler={this.resetSelect}
                secondary
              />
            </div>
          )}
        </BottomToast>
        <ArrowButton onClick={this.navigateToBack} padLeft={sidebarStatus ? 125 : 125} />
        <div className="main-label-no-transform">
          <span>Select Media</span>
        </div>
        <div className="filters-wrapper">
          <DashboardFilter
            name={appFilterName}
            status={currentAppFilter.status}
            values={transformedApps}
            changeHandler={this.filterChangeHandler}
            value={String(currentAppFilter.value)}
            label="By Apps"
          />

          <DashboardFilter
            name={campaignFilterName}
            status={currentCampaignFilter.status}
            values={this.transformWithFirstValue(currentAppCampaigns)}
            changeHandler={this.filterChangeHandler}
            value={currentCampaignFilter.value}
            label="By campaigns"
          />
        </div>
        <div className="library-wrapper">
          <MediaLibraryPlaceholder
            itemsLength={Object.keys(sortedMedias).length}
          />
          {/* {campaignId && appId ?
          // (Object
          //   .keys(sortedMedias)
          //   .length !== 0 &&
          //    mediaApps
          //    .map(mediaApp =>
          //    this.renderAppMedia(mediaApp, sortedMedias, currentCampaignFilter.value))) */}
          {/* : */}
          <InfinityLoader
            rowCount={rowCount}
            loadMoreRows={this.loadMoreRows}
            isRowLoaded={this.isRowLoaded}
          >
            {({ onRowsRendered, registerChild }) => (
              <AutoSizer>
                {({ width, height }) => (
                  <List
                    ref={(el) => {
                      this.virtualElement = el;
                      registerChild(el);
                    }}
                    onRowsRendered={onRowsRendered}
                    rowRenderer={this.rowRenderer}
                    width={width}
                    height={height}
                    rowCount={rowCount}
                    deferredMeasurementCache={cache}
                    rowHeight={cache.rowHeight}
                  />
                )}
              </AutoSizer>
            )}
          </InfinityLoader>
        </div>
      </div>
    );
  }
}

export default MediaLibraryFull;



// WEBPACK FOOTER //
// ./src/components/_molecules/MediaLibraryFull/MediaLibraryFull.js